import { IntegrationAppClient } from '@integration-app/react';

export enum IntegrationKey {
  HUBSPOT = 'hubspot',
  SALESFORCE = 'salesforce',
  GOHIGHLEVEL = 'gohighlevel',
  LEADDOCKET = 'lead-docket',
  MONDAY = 'monday',
  TLD_CRM = 'total-lead-domination',
  ACTIVECAMPAIGN = 'activecampaign',
  SALESFORCE_PARDOT = 'salesforce-pardot',
}

export enum DataSourceKey {
  CONTACTS = 'contacts',
}

export enum IntegrationAppActionKey {
  SEND_EMAIL = 'send_email',
  SEND_MESSAGE = 'send_message',
}

export enum ContactRecordField {
  ID = 'id',
  PRIMARY_PHONE = 'primaryPhone',
  PRIMARY_EMAIL = 'primaryEmail',
  FULL_NAME = 'fullName',
}

// https://console.integration.app/docs/membrane/references/udm
export interface ContactRecord {
  id: string;
  fields: {
    [ContactRecordField.ID]: string;
    [ContactRecordField.PRIMARY_PHONE]?: string;
    [ContactRecordField.PRIMARY_EMAIL]?: string;
    [ContactRecordField.FULL_NAME]?: string;
  };
}

export interface ListActionResponse<T> {
  records: T[];
  cursor?: string;
}

export interface ListActionAdditionalParams {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export async function listAction<T>({
  client,
  integrationKey,
  dataSourceKey,
  cursor,
  query,
  maxRecords,
  onError,
  ...customParams
}: {
  client: IntegrationAppClient;
  integrationKey: string | null;
  dataSourceKey: string;
  cursor?: string;
  query?: string;
  maxRecords?: number;
  onError?: (error: Error) => void;
}): Promise<ListActionResponse<T>> {
  if (!integrationKey) {
    return { records: [] };
  }

  try {
    const response = await client
      .connection(integrationKey)
      .action(`list-${dataSourceKey}`)
      .run({
        cursor,
        query,
        ...customParams,
      });

    const records = response.output.records as T[];
    const limitedRecords = maxRecords ? records.slice(0, maxRecords) : records;

    return {
      records: limitedRecords,
      cursor: response.output.cursor,
    };
  } catch (error) {
    console.error(`Error fetching ${dataSourceKey} from CRM:`, error);
    const errorObj =
      error instanceof Error ? error : new Error('Unknown error occurred');
    onError?.(errorObj);
    throw errorObj;
  }
}
